module.exports = __webpack_public_path__ + "img/19.3.TP.58213d5a.png";